import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import Box from '../atoms/Box';

const DropDownMenu = ({ component, button, className, closeOnClick, block, forceToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    /**
     * @param {React.MouseEvent<HTMLElement>} e
     */
    const handleClick = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target) && isOpen) {
        setIsOpen(false);
      }
    };
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, [dropdownRef, isOpen]);

  const toggle = () => {
    if (!isOpen || (isOpen && closeOnClick)) setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (forceToggle) toggle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceToggle]);

  return (
    <Box ref={dropdownRef}
      onClick={() => toggle()}
      className={`dropdown ${block ? 'dropdown__block' : ''}`}>
      <div>
        {button ? (
          button(isOpen)
        ) : (
          <Button className="transparent trimmed ph-half" data-cy="default-dropdown-toggle">
            <i className={`t-xxl icon icon-more-horizontal- ${isOpen && 't-main'}`} />
          </Button>
        )}
      </div>
      {isOpen && <div className={`dropdown_content ${className}`}>{component()}</div>}
    </Box>
  );
};

DropDownMenu.defaultProps = {
  className: '',
  closeOnClick: true
};

DropDownMenu.propTypes = {
  t: PropTypes.func,
  component: PropTypes.func,
  button: PropTypes.func,
  className: PropTypes.string,
  closeOnClick: PropTypes.bool,
  block: PropTypes.bool,
  forceToggle: PropTypes.number
};

export default DropDownMenu;
